export default __webpack_public_path__ + "assets/equatorialguinea-flag.png";